var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserversalSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5499_132936)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6869 2.31295C13.7348 2.36089 13.771 2.41614 13.7954 2.47511L13.333 2.1665H13.3334L13.3364 2.16651C13.4031 2.1669 13.4667 2.18036 13.5247 2.20444C13.5837 2.22884 13.639 2.26501 13.6869 2.31295ZM13.7954 2.47511L13.8334 2.66699V2.6665L13.8333 2.6635C13.833 2.5968 13.8195 2.5332 13.7954 2.47511ZM12.8334 3.1665V3.87361L9.68691 7.02006C9.49164 7.21532 9.17506 7.21532 8.9798 7.02006C8.78454 6.8248 8.78454 6.50821 8.9798 6.31295L12.1262 3.1665H12.8334ZM3.16669 5.1665C3.16669 4.33808 3.83826 3.6665 4.66669 3.6665H8.83335C9.1095 3.6665 9.33335 3.44265 9.33335 3.1665C9.33335 2.89036 9.1095 2.6665 8.83335 2.6665H4.66669C3.28597 2.6665 2.16669 3.78579 2.16669 5.1665V11.3332C2.16669 12.7139 3.28597 13.8332 4.66669 13.8332H11.3334C12.7141 13.8332 13.8334 12.7139 13.8334 11.3332V7.49984C13.8334 7.22369 13.6095 6.99984 13.3334 6.99984C13.0572 6.99984 12.8334 7.22369 12.8334 7.49984V11.3332C12.8334 12.1616 12.1618 12.8332 11.3334 12.8332H4.66669C3.83826 12.8332 3.16669 12.1616 3.16669 11.3332V5.1665Z",
    fill: "#FC6524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5499_132936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserversalSearchIcon);
export default __webpack_public_path__ + "static/media/userversal-search-icon.930f0c944ef9976541abe3cca3a956a6.svg";
export { ForwardRef as ReactComponent };